import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { CTA, HtmlRaw, Text } from '../../../atoms';
import { Body, CTAWrapper, Image, ArticleTitle } from './style';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';

const Article = ({ data, firstArticle, mediaIsPhone }) => {
  const navigate = useNavigate();

  const handleOnClick = ({ data: link, type }) => {
    if (type === 'external_link') window.open(link?.uri);
    else navigate(link?.path);
  };

  return (
    <Body hasImg={data?.cover} className={data?.type}>
      <div>
        <ArticleTitle className={firstArticle ? 'first' : ''}>
          {data?.title}
        </ArticleTitle>
        {data?.cover && (
          <Image src={data?.cover?.src} alt={data?.cover?.alt} className={data?.type} />
        )}
        <Text type="b3" className="description">
          <HtmlRaw html={data?.body} />
        </Text>
        {data?.link?.data && (
          <CTAWrapper>
            <CTA
              btnText={data.link?.data?.title || data.link?.data?.text || ''}
              onClick={() => handleOnClick(data.link)}
            />
          </CTAWrapper>
        )}
      </div>
    </Body>
  );
};

Article.propTypes = {
  mediaIsPhone: PropTypes.bool,
  data: PropTypes.object,
  firstArticle: PropTypes.bool,
};

export default withMediaQueries(Article);
